<template>
    <Head title="Mural de Campanhas" />

    <AuthenticatedLayout>
        <Heading title="Mural de Campanhas" class="xl:px-[16vw] pt-24"/>
        <div class="component-background-desktop">
            <div class="flex flex-col justify-center items-center gap-y-12 px-4">
                <Post v-for="(data, key) in data" :postId="data.post.id" :midia="data.post.midia" :liked="data.liked" :key="key" :perfilPhoto="data.post.postProfile.avatar" :author="data.post.postProfile.name" :createdDate="data.post.createdAt" :text="data.post.text" :url="data.post.midia" :link="data.post.midia" class="max-w-[609px]" />
            </div>
            <!-- <div class="flex flex-col justify-center items-center gap-y-12 px-4">
                <Post v-for="(post, key) in postsMock" :key="key" :perfilPhoto="post.perfilPhoto" :author="post.author" :createdDate="post.createdDate" :text="post.text" :url="post.url" :link="post.link" class="max-w-[609px]" />
            </div> -->
            <div class="flex justify-center">
                <div class="flex px-4 mt-10 mb-14 gap-x-5">
                    <div class="text-yellow flex justify-center items-center cursor-pointer text-xl" :class="select ? 'text-yellow' : 'text-white bg-primary' ">
                        Ver mais
                        <div>
                            <svg id="Chevron_-_Médio_-_Ícone" data-name="Chevron - Médio - Ícone" xmlns="http://www.w3.org/2000/svg" width="13.182" height="8" viewBox="0 0 13.182 8">
                                <g id="Chevron" transform="translate(13.182 0) rotate(90)">
                                    <path id="Caminho_10434" data-name="Caminho 10434" d="M7.788,7.1,1.921,12.97a.724.724,0,0,1-1.025,0l-.684-.684a.724.724,0,0,1,0-1.023l4.65-4.671L.211,1.92A.724.724,0,0,1,.212.9L.9.212a.724.724,0,0,1,1.025,0L7.788,6.079A.725.725,0,0,1,7.788,7.1Z" transform="translate(0 0)" fill="#ffe97d"/>
                                </g>
                            </svg>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </AuthenticatedLayout>
</template>
<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Heading from '@/Components/UI/Texts/Heading.vue';
import { Head } from "@inertiajs/inertia-vue3";
import Post from "@/Components/Post.vue"

export default {
    components: {
        AuthenticatedLayout,
        Heading,
        Head,
        Post
    },
    props: {
        data: Object
    },
    data() {
        return {
            select: true,
            postsMock: [
                {
                    perfilPhoto : '/images/Banner_Resgate_Mobile.jpg',
                    author : "João Pedro",
                    createdDate : "13/10 às 15h46",
                    text: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
                    url: "https://www.youtube.com/watch?v=PsO6ZnUZI0g",
                    link: "https://www.youtube.com/watch?v=PsO6ZnUZI0g",

                },
                {
                    perfilPhoto : '/images/Banner_Resgate_Mobile.jpg',
                    author : "João Pedro",
                    createdDate : "13/10 às 15h46",
                    text: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
                    url: "https://www.youtube.com/watch?v=PsO6ZnUZI0g",
                    link: "https://www.youtube.com/watch?v=PsO6ZnUZI0g",

                },
                {
                    perfilPhoto : '/images/Banner_Resgate_Mobile.jpg',
                    author : "João Pedro",
                    createdDate : "13/10 às 15h46",
                    text: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
                    url: "https://www.youtube.com/watch?v=PsO6ZnUZI0g",
                    link: "https://www.youtube.com/watch?v=PsO6ZnUZI0g",

                },
            ]
        }
    }
}
</script>
